import React, { useRef } from 'react';
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap";

/**
 * Contactdistributor Component
 * Sends form data directly to WhatsApp using the Click-to-Chat API.
 */
export const Contactform = () => {
    const formRef = useRef();

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        // 1. Extract values from the form using the ref
        const formData = new FormData(formRef.current);
        const data = {
            name: formData.get('from_name'),
            mobile: formData.get('from_mobile'),
            city: formData.get('from_city'),
            category: formData.get('from_category'),
            category2: formData.get('from_category2'),
            queries: formData.get('from_queries')
        };

        // 2. Define your WhatsApp Number (Include Country Code, No '+' or '-')
        // Example: 91 for India + 7550967009
        const myPhoneNumber = "917550967009";

        // 3. Construct the message with Line Breaks (%0a) and Bold Text (*)
        const message = `*UNICORN AEROCITY PLOT*%0a` +
            `--------------------------%0a` +
            `*Name:* ${data.name}%0a` +
            `*Mobile:* ${data.mobile}%0a` +
            `*City:* ${data.city}%0a` +
            `*Requirement phase I:* ${data.category}%0a` +
                `*Requirement phase II:* ${data.category2}%0a` +
            `*Message:* ${data.queries}`;

        // 4. Generate the URL and open in a new tab
        const whatsappUrl = `https://wa.me/${myPhoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className='album py-2 bg-light'>
            <Container>
                <Row className="justify-content-center">
                    <Col md={12}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-3">
                                <div className="text-center mb-3">
                                    <h3 className='fw-bold' style={{ color: '#18444c' }}>Unicorn Aerocity </h3>
                                    <p className="text-muted small">Premium Villa Plots Near Kolkata Airport. Contact us for details and site visit.</p>
                                </div>

                                <Form ref={formRef} onSubmit={handleWhatsAppSubmit}>
                                    {/* Name Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            name="from_name"
                                            placeholder="Full Name"
                                            required
                                        />
                                    </Form.Group>

                                    {/* Mobile Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="tel"
                                            name="from_mobile"
                                            placeholder="Mobile Number"
                                            required
                                        />
                                    </Form.Group>

                                    {/* City Field */}
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            name="from_city"
                                            placeholder="City"
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Select name="from_category" >
                                            <option value="">Pre launching offer on Unicorn Aerocity phase I </option>
                                            <option value="1000 sqft - ₹40 Lakhs*">1000 sqft - ₹40 Lakhs*</option>
                                            <option value="2000 sqft - ₹75 Lakhs*">
                                                2000 sqft - ₹75 Lakhs*</option>
                                            <option value="4000 sqft - ₹1.40 Cr*">
                                                4000 sqft - ₹1.40 Cr*</option>
                                        </Form.Select>
                                    </Form.Group>
                                     <Form.Group className="mb-3">
                                        <Form.Select name="from_category2" required>
                                            <option value="">Pre launching offer on Unicorn Aerocity phase I I </option>
                                            <option value="1200 sqft - ₹51 Lakhs*">1200 sqft - ₹51 Lakhs*</option>
                                            <option value="2000 sqft - ₹81 Lakhs*">
                                                2000 sqft - ₹81 Lakhs* Criteria G+2</option>
                                           
                                        </Form.Select>
                                    </Form.Group>
                                    {/* Queries Field */}


                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="from_queries"
                                            placeholder="Enter your queries..."
                                            required
                                        />
                                    </Form.Group>

                                    <div className="d-grid gap-2">
                                        <Button variant="success" type="submit" >
                                            Send to WhatsApp
                                        </Button>
                                    </div>
                                </Form>
                                   <div className="d-flex justify-content-center align-items-center mb-0">
                                <a style={{color:"blue"}} className='me-5 mt-3'  href='https://www.facebook.com/profile.php?id=61551236967321' target="_blank" rel="noopener noreferrer" >Facebook</a>
                                <a style={{color:"maroon"}} className='mt-3' href='https://www.instagram.com/novestagroup.suman' target="_blank" rel="noopener noreferrer">Instagram</a>
                             </div>
                            </Card.Body>
                          
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};